// Меню админа. В меню только разделы, за которыми стоит API (у остальных ролей — data/menus.js).
export const MENU_ITEMS = [
  { id: 1, name: "Сводка", link: "/Adashboard", icon: "si si-speedometer" },
  { id: 2, name: "Пользователи", link: "/control", icon: "si si-people" },
  { id: 3, name: "Клиенты", link: "/client-profiles", icon: "si si-users" },
  { id: 4, name: "Гиды", link: "/guide-profiles", icon: "si si-user-follow" },
  { id: 5, name: "Страховщики", link: "/insurer-profiles", icon: "si si-shield" },
  { id: 6, name: "Шаблоны туров", link: "/tour-templates", icon: "si si-map" },
  { id: 7, name: "Доп. услуги", link: "/extra-services", icon: "si si-plus" },
  { id: 8, name: "Транспорт", link: "/vehicles", icon: "fa fa-car-side" },
  { id: 28, name: "Календарь транспорта", link: "/vehicle-calendar", icon: "si si-calendar" },
  { id: 9, name: "Типы транспорта", link: "/vehicle-types", icon: "si si-list" },
  { id: 10, name: "Бронирования", link: "/vehicle-bookings", icon: "si si-clock" },
  { id: 11, name: "Заказы", link: "/orders", icon: "si si-basket" },
  { id: 29, name: "Позиции заказов", link: "/order-items", icon: "si si-list" },
  { id: 12, name: "Участники туров", link: "/tour-participants", icon: "si si-user" },
  { id: 13, name: "Корзины", link: "/carts", icon: "si si-handbag" },
  { id: 14, name: "Предложения", link: "/personal-offers", icon: "si si-present" },
  { id: 15, name: "Страховые запросы", link: "/insurance-requests", icon: "si si-docs" },
  { id: 16, name: "Техподдержка", link: "/support-tickets", icon: "si si-support" },
  { id: 17, name: "Документы", link: "/documents", icon: "si si-doc" },
  { id: 18, name: "Платежи", link: "/payments", icon: "si si-credit-card" },
  {
    id: 19,
    name: "Аналитика",
    icon: "si si-graph",
    sub: [
      { id: 191, name: "Выручка по видам доходов", link: "/analytics/revenue-by-tour-type" },
      { id: 192, name: "Загрузка транспорта", link: "/analytics/vehicle-utilization" },
      { id: 197, name: "Заказы гидов", link: "/analytics/guide-orders" },
      { id: 193, name: "Статистика клиентов", link: "/analytics/client-statistics" },
      { id: 194, name: "Эффективность гидов", link: "/analytics/guide-performance" },
      { id: 195, name: "Тренды бронирований", link: "/analytics/booking-trends" },
      { id: 196, name: "Выручка по времени", link: "/analytics/revenue-over-time" },
    ],
  },
  {
    id: 20,
    name: "Отчеты",
    icon: "si si-doc",
    sub: [
      { id: 201, name: "Продажи", link: "/reports/sales" },
      { id: 202, name: "Клиенты", link: "/reports/clients" },
      { id: 203, name: "Транспорт", link: "/reports/vehicles" },
      { id: 204, name: "Гиды", link: "/reports/guides" },
    ],
  },
  { id: 25, name: "Уведомления", link: "/notifications", icon: "si si-bell" },
  { id: 26, name: "Контакты для клиентов", link: "/company-settings", icon: "si si-phone" },
  {
    id: 27,
    name: "Система",
    icon: "si si-link",
    sub: [
      { id: 271, name: "Состояние системы", link: "/status" },
      { id: 272, name: "Проверка здоровья", link: "/health" },
    ],
  },
];
